<template>
  <div>
    <!-- MODO “TELA NORMAL” -->
    <div v-if="!printMode">
      <h6>Grade Horária do Professor x Qtd. de Alunos</h6>
      <p></p>
      <div class="row mb-3">
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- MODO “IMPRESSÃO / PRINT” -->
    <div v-else class="relatorio-body" :data-user="userName">
      <div v-if="loading">Carregando…</div>

      <div v-else-if="instrutores.length">
        <div
          v-for="(prof, idxProf) in instrutores"
          :key="'prof-' + idxProf"
          class="mb-4"
        >
        <!-- 🔷 QUADRO RESUMO DO INSTRUTOR -->
        <div
            class="resumo-instrutor mb-2 p-2 border rounded"
            :data-instrutor="prof.instrutor_nome"
            :data-total-aulas="totalAulas(prof)"
            :data-total-alunos="totalAlunos(prof)"
        >
            <strong>Instrutor:</strong> {{ prof.instrutor_nome }} <br>
            <strong>Aulas:</strong> {{ totalAulas(prof) }} <br>
            <strong>Alunos:</strong> {{ totalAlunos(prof) }}
        </div>

          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 10%;">#</th>
                <th style="width: 25%;">Dias de aula</th>
                <th style="width: 15%;">Horário</th>
                <th style="width: 30%;">Nível/Turma</th>
                <th style="width: 20%;" class="text-center">Qtd. Alunos</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(aula, idxAula) in prof.aulas"
                :key="'aula-' + idxProf + '-' + idxAula"
              >
                <td>{{ aula.id }}</td>
                <td>{{ aula.dia_semana }}</td>
                <td>{{ formatarHorario(aula.horario) }}</td>
                <td>{{ aula.nivel }}</td>
                <td class="text-center">{{ aula.qtd_alunos }}</td>
              </tr>
            </tbody>
          </table>
            <!-- Total de alunos por instrutor -->
            <p class="text-end" style="font-style: italic;">
                Total de alunos: {{ totalAlunos(prof) }}
            </p>
        </div>
      </div>
      <div
        v-if="metrics && printMode"
        class="mt-4 grade-metrics"
        :data-alunos-distintos="metrics.alunos_distintos"
        :data-total-vinculos="metrics.total_vinculos"
        :data-alunos-multiturmas="metrics.alunos_multiturmas"
      >
        <p style="font-size: 12px;">
          <strong>Resumo:</strong><br>
          - Alunos distintos na grade: {{ metrics.alunos_distintos }} <br>
          - Total de posições de aula (vínculos): {{ metrics.total_vinculos }} <br>
          - Alunos em mais de uma turma: {{ metrics.alunos_multiturmas }}
        </p>
      </div>

      <div v-else>
        <p class="text-muted">Nenhum registro encontrado.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  printTitle: String
})

const router      = useRouter()
const loading     = ref(false)
const instrutores = ref([])
const metrics = ref({})

/**
 * Carrega dados do backend
 */
async function carregarDados () {
  loading.value = true
  try {
    const res = await axios.get('/gestao/relatorios/operacionais/grade-horaria-professor')
    instrutores.value = Array.isArray(res.data.instrutores)
      ? res.data.instrutores
      : []

    metrics.value = res.data.metrics || {}
  } catch (e) {
    console.error('Erro em GradeHorariaProfessor (print):', e)
    instrutores.value = []
  } finally {
    loading.value = false
  }
}

function contarDias (diasStr) {
  if (!diasStr) return 0
  // "quarta-feira + sexta-feira" => ['quarta-feira','sexta-feira'] => 2
  return diasStr
    .split('+')
    .map(d => d.trim())
    .filter(Boolean).length
}

function totalAulas (prof) {
  if (!prof || !Array.isArray(prof.aulas)) return 0
  return prof.aulas.reduce((acc, aula) => {
    return acc + contarDias(aula.dia_semana)
  }, 0)
}

function totalAlunos (prof) {
  if (!prof || !Array.isArray(prof.aulas)) return 0
  return prof.aulas.reduce((acc, aula) => {
    return acc + (aula.qtd_alunos || 0)
  }, 0)
}

/**
 * Quando em printMode, carrega os dados ao montar
 */
onMounted(() => {
  if (props.printMode) {
    carregarDados()
  }
})

/**
 * Botão "Executar" em modo tela
 */
function abrirPrint () {
  router.push({
    path: '/gestao/relatorios/print/grade-horaria-professor',
    query: {
      title: 'Grade Horária do Professor x Qtd. de Alunos'
    }
  })
}

/**
 * Formata horário HH:MM:SS -> HH:MM
 */
function formatarHorario (horaStr) {
  if (!horaStr) return ''
  // Se vier 'HH:MM:SS', pega só HH:MM
  const partes = horaStr.split(':')
  if (partes.length >= 2) {
    return `${partes[0].padStart(2, '0')}:${partes[1].padStart(2, '0')}`
  }
  return horaStr
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.mb-4 {
  margin-bottom: 1.5rem;
}
.text-center {
  text-align: center !important;
}
.resumo-instrutor {
  background: #f8f9fa;        /* leve cinza claro */
  font-size: 13px;
  line-height: 1.4;
}

</style>
